import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/polls/poll.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { openModal } from 'soapbox/actions/modals';
import { vote } from 'soapbox/actions/polls';
import { useAppDispatch, useAppSelector } from 'soapbox/hooks';
import { Stack, Text } from '../ui';
import PollFooter from './poll-footer';
import PollOption from './poll-option';
const messages = defineMessages({
  multiple: {
    "id": "poll.chooseMultiple",
    "defaultMessage": "Choose as many as you'd like."
  }
});
const Poll = ({
  id,
  status
}) => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const isLoggedIn = useAppSelector(state => state.me);
  const poll = useAppSelector(state => state.polls.get(id));
  const [selected, setSelected] = useState({});
  const openUnauthorizedModal = () => dispatch(openModal('UNAUTHORIZED', {
    action: 'POLL_VOTE',
    ap_id: status
  }));
  const handleVote = selectedId => dispatch(vote(id, [String(selectedId)]));
  const toggleOption = value => {
    if (isLoggedIn) {
      if (poll?.multiple) {
        const tmp = _objectSpread({}, selected);
        if (tmp[value]) {
          delete tmp[value];
        } else {
          tmp[value] = true;
        }
        setSelected(tmp);
      } else {
        const tmp = {};
        tmp[value] = true;
        setSelected(tmp);
        handleVote(value);
      }
    } else {
      openUnauthorizedModal();
    }
  };
  if (!poll) return null;
  const showResults = poll.voted || poll.expired;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React.createElement("div", {
      onClick: e => e.stopPropagation(),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 5
      }
    }, !showResults && poll.multiple && /*#__PURE__*/React.createElement(Text, {
      theme: "muted",
      size: "sm",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 9
      }
    }, intl.formatMessage(messages.multiple)), /*#__PURE__*/React.createElement(Stack, {
      space: 4,
      className: "mt-4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Stack, {
      space: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 9
      }
    }, poll.options.map((option, i) => /*#__PURE__*/React.createElement(PollOption, {
      key: i,
      poll: poll,
      option: option,
      index: i,
      showResults: showResults,
      active: !!selected[i],
      onToggle: toggleOption,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 78,
        columnNumber: 13
      }
    }))), /*#__PURE__*/React.createElement(PollFooter, {
      poll: poll,
      showResults: showResults,
      selected: selected,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 9
      }
    })))
  );
};
export default Poll;